export default __webpack_public_path__ + "static/media/app-pic-4.e51bb9d9.png";